import { useCallback, useState } from 'react';
import { Button, ButtonColors, ButtonHeight } from '~/components/ui/Button';
import { BgPlaceholder, PlaceholderType } from '~/components/ui/BgPlaceholder';
import { LayoutBuilder } from '~/rage/utils';
import { rage, useObservable } from '~/rage';
import { Layouts, ModalButtonColor, ModalType, WalletType } from '~/shared';
import { Modal } from './components/Modal';

const placeholderTypes = Object.values(PlaceholderType);

const StubControls: React.FC = () => {
	const layouts = useObservable(rage.gui.getVisibleLayouts());
	const isOnlyVisible = layouts.length === 1 && layouts[0] === Layouts.Modal;
	const isStub = rage.config.isStub();
	const [backgroundIndex, setBackgroundIndex] = useState(0);

	const handleShowDefaultModal = useCallback(() => {
		rage.modal.showModal(
			{
				type: ModalType.Default,
				acceptButton: { color: ModalButtonColor.Success, text: 'Принять' },
				cancelButton: { color: ModalButtonColor.Secondary, text: 'Отмена' },
				text: 'Текст заглушки модального окна',
				title: 'Заголовок заглушки модального окна',
			},
			(result: { isAccepted: boolean }) => console.log('Modal result:', result),
		);
	}, []);

	const handleShowInviteModal = useCallback(() => {
		rage.modal.showModal(
			{
				type: ModalType.Invite,
				title: 'Игрок #1111 приглашает вас сыграть в Камень-Ножницы-Бумага',
				inviteExpirationTime: 10000,
			},
			(result: { isAccepted: boolean }) => console.log('Modal result:', result),
		);
	}, []);

	const handleShowBusinessWithdrawCashModal = useCallback(() => {
		rage.modal.showModal(
			{
				type: ModalType.BusinessWithdraw,
				title: 'Снятие средств',
				text: 'Введите в поле ниже сумму, которую вы хотите взять из кассы вашего бизнеса "Заправка LTD №14"',
				balanceLabel: 'Денег в кассе',
				balance: 8_900_000,
				taxPercent: 1.5,
				wallet: WalletType.Cash,
				acceptButton: {
					color: ModalButtonColor.Success,
					text: 'Забрать деньги',
				},
				cancelButton: { color: ModalButtonColor.Secondary, text: 'Отменить' },
			},
			(result) => console.log('Modal result:', result),
		);
	}, []);

	const handleShowBusinessWithdrawAccountModal = useCallback(() => {
		rage.modal.showModal(
			{
				type: ModalType.BusinessWithdraw,
				title: 'Забрать средства',
				text: 'Введите в поле ниже сумму, которую вы хотите вывести со счёта вашего бизнеса "Заправка LTD №14"',
				balanceLabel: 'Денег на счету',
				balance: 8_900_000,
				taxPercent: 1.5,
				wallet: WalletType.Bank,
				acceptButton: {
					color: ModalButtonColor.Success,
					text: 'Вывести деньги',
				},
				cancelButton: { color: ModalButtonColor.Secondary, text: 'Отменить' },
			},
			(result) => console.log('Modal result:', result),
		);
	}, []);

	const handleCycleBackground = useCallback(() => {
		setBackgroundIndex((prev) => (prev + 1) % placeholderTypes.length);
	}, []);

	if (!isStub || !isOnlyVisible) return null;

	return (
		<>
			<div style={{ position: 'fixed', inset: 0, zIndex: -2 }}>
				<BgPlaceholder $type={placeholderTypes[backgroundIndex]} />
			</div>
			<div
				style={{
					position: 'fixed',
					top: '50%',
					left: '50%',
					transform: 'translate(-50%, -50%)',
					display: 'flex',
					flexDirection: 'column',
					gap: 8,
					padding: 8,
					background: '#111314',
					border: '1px solid rgba(255, 255, 255, 0.1)',
					borderRadius: 10,
					boxShadow: '0 0 30px rgba(0, 0, 0, 0.5)',
					zIndex: -1,
					fontFamily: "'GT Walsheim Pro', sans-serif",
				}}
			>
				<Button
					color={ButtonColors.Select}
					height={ButtonHeight.Height30}
					onClick={handleShowDefaultModal}
				>
					Показать стандартное окно
				</Button>
				<Button
					color={ButtonColors.Select}
					height={ButtonHeight.Height30}
					onClick={handleShowInviteModal}
				>
					Показать приглашение
				</Button>
				<Button
					color={ButtonColors.Select}
					height={ButtonHeight.Height30}
					onClick={handleShowBusinessWithdrawCashModal}
				>
					Снятие из кассы
				</Button>
				<Button
					color={ButtonColors.Select}
					height={ButtonHeight.Height30}
					onClick={handleShowBusinessWithdrawAccountModal}
				>
					Снятие со счёта
				</Button>
				<Button
					color={ButtonColors.Select}
					height={ButtonHeight.Height30}
					onClick={handleCycleBackground}
				>
					Фон {backgroundIndex + 1}/{placeholderTypes.length}
				</Button>
			</div>
		</>
	);
};

const LayoutComponent = () => {
	return (
		<>
			<Modal />
			<StubControls />
		</>
	);
};

const Layout = new LayoutBuilder(LayoutComponent)
	.setDisplayName(Layouts.Modal)
	.setHudVisible(true)
	.build();

export default Layout;
